<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0"><router-link to="/compras/">
            <i class="fas fa-caret-square-left text-secondary"></i>
                    </router-link> Nueva compra</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item"><router-link :to="{ name:'compras'}">Compras</router-link></li>
            <li class="breadcrumb-item active">Nuevo</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
  <!--nuevo comentario-->
            <div class="card card-primary">
              <div class="card-header">
                <h3 class="card-title">Registrar nueva compra</h3>
              </div>
              <!-- /.card-header -->
              <div class="card-body">
                    <div class="row">
                    <div class="col-sm-4">
                      <!-- text input -->
                      <div class="form-group">
                        <label>Seleccionar Proveedor <button class="btn btn-primary btn-sm toastrDefaultSuccess" @click="abrirModalPro('registrar')">+</button></label>
                        <VueMultiselect
                            v-model="proveedSelect"
                            :options="arrayProveedor"
                            :custom-label="nameWithLang"
                            :show-labels="false"
                            :searchable="true"
                            :select-label="placeholderSelectPro"
                            @search-change= 'buscarProveedor'
                            />
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>RUC</label>
                        <input type="text" v-if="proveedSelect" class="form-control" readonly v-model="proveedSelect.ruc">
                        <input type="text" v-else class="form-control" readonly placeholder="Sin seleccionar">
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Fecha de compra</label>
                        <input type="date" class="form-control" v-model="fechaCompra">
                      </div>
                    </div> 
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Almacen destino</label>
                        <select class="form-control" v-model="idAlmacen">
                          <option :value="0">Seleccione</option>
                          <option :value="al.id"  v-for="al in arrayAlmacen" :key="al.id">{{ al.nombre }}</option>
                        </select>
                      </div>
                    </div> 
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Comprobante de compra</label>
                        <select class="form-control" v-model="idTipoComprob">
                          <option :value="0">Seleccione</option>
                          <option :value="tip.id"  v-for="tip in arrayTipoComp" :key="tip.id">{{ tip.nombre }}</option>
                        </select>
                      </div>
                    </div> 
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label>Numero de comprobate</label>
                        <input type="text" class="form-control" placeholder="A000-0001" v-model="numeroComprob" style="text-transform:uppercase;">
                      </div>
                    </div> 
                    
                  </div>
                  <div class="card card-secondary">
                    <div class="card-header">
                      Agregar productos de compra
                    </div>
                    <div class="card-body" v-on:keyup.enter="addListProd()">
                      <div class="row">
                        <div class="col-sm-6">
                          <label>Buscar producto</label>
                          <VueMultiselect
                            v-model="productoSelect"
                            :options="arrayProducto"
                            :custom-label="nameWithLangPro"
                            :show-labels="false"
                            :searchable="true"
                            :select-label="placeholderSelectPro"
                            @search-change= 'buscarProducto'
                            @input="onProductoChange"
                            />
                        </div>
                        <div class="col-sm-2" v-if="conmodelo=productoSelect.tieneModelo">
                            <label>Modelo</label>
                          <div class="input-group">
                            <input type="text" class="form-control" placeholder="Modelo" v-model="modelo" style="text-transform: uppercase;">
                          </div>
                        </div>
                        <div class="col-sm-2" v-if="conserie=productoSelect.tieneSerie">
                            <label>Serie</label>
                          <div class="input-group">
                            <input type="text" class="form-control" placeholder="Serie" v-model="serie" style="text-transform: uppercase;">
                          </div>
                        </div>
                        <div class="col-sm-2" v-if="confechaven=productoSelect.tieneVencimiento">
                            <label>Fecha Vencimiento</label>
                          <div class="input-group">
                            <input type="date" class="form-control" v-model="fvencimiento">
                          </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label>Unidad de Compra</label>
                                <select class="form-control" v-model="idUnidadMedida">
                                <option :value="0">Seleccione</option>
                                <option :value="u"  v-for="u in arrayUniMedida" :key="u.id">{{ u.nombre+' - '+u.proporcion }}</option>
                                </select>
                            </div>
                        </div> 
                        <div class="col-sm-2">
                            <label>Cantidad</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text"><i class="fas fa-calculator"></i></span>
                            </div>
                            <input type="number" class="form-control" placeholder="000" v-model="inputCantidad">
                          </div>
                        </div>
                        <div class="col-sm-2">
                            <label>Costo de compra x Uni-Medi</label>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text"><i class="fas fa-dollar-sign"></i></span>
                            </div>
                            <input type="number" class="form-control" placeholder="00.00" v-model="inputPrecio">
                          </div>
                        </div>
                        <div class="col-sm-2">
                            <label>Accion</label>
                          <div class="input-group">
                            <button type="button" class="btn btn-success"
                              @click="addListProd()">
                              <i class="fas fa-plus-square"></i> AGREGAR</button>
                          </div>
                        </div>
                      </div>


                      <label class="mt-3">Lista de productos:</label> 
                      <div class="row">
                        <div class="col-sm-12">
                          <table class="table table-sm table-bordered table-striped">
                            <thead class="bg-info">
                              <tr>
                                <th>#</th>
                                <th>x</th>
                                <th>Producto</th>
                                <th>Unidad de Compra</th>
                                
                                <th>Modelo</th>
                                <th>Serie</th>
                                <th>F. vencimi</th>
                                <th>Cantidad</th>
                                <th>Precio de Compra</th>
                                <th class="text-right">SubTotal</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(list,index) in  arrayProductoAdd" :key="list">
                                <td>{{index+1}}</td>
                                <td>
                                  <button class="btn btn-sm btn-danger" @click="eliminarItem(index)"><i class="fas fa-trash-alt"></i></button>
                                </td>
                                <td>{{ list.producto }} - {{ list.marca }}</td>
                                <td>{{ list.unidadMedida }}</td>
                                <td style="text-transform: uppercase;">{{ list.modelo }}</td>
                                <td style="text-transform: uppercase;">{{ list.serie }}</td>
                                <td>{{ fechaFormateada(list.fvencimiento) }}</td>
                                <td>
                                  <input v-model.number="list.cantidad" class="form-control" @keyup="recalcularItem(index)"/>  
                                </td>
                                <td>
                                  <input v-model.number="list.precio" class="form-control" @keyup="recalcularItem(index)"/>  
                                </td>  
                                <td class="text-right"><strong>{{ formattedTotal(list.subtotal) }}</strong>  </td>  
                              </tr>
                              <tr>
                                <td colspan="9" class="text-right">
                                  <h4>Total</h4>
                                </td>
                                <td class="text-right">
                                  <h4>{{ formattedTotal(sumatotal=sumaTotal) }}</h4>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.card-body -->
                <div class="card-footer">
                  <div class="text-center">
                    <button type="button" class="btn btn-primary" @click="grabarCompra()"><i class="fas fa-save"></i> GRABAR COMPRA</button>
                  </div>                  
                </div>
                <!-- /.card-footer -->
            </div>
            

  <!--- MODAL PEDIDO --->
     <div v-if="showModal">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarCategoria():actualizarCategoria()">
                  <div class="modal-header bg-primary text-white">
                      <h4>{{tituloModal}}</h4>
                      <button type="button" class="close" @click="cerrarModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="nombre" placeholder="Nombre de la categoria">
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Descripción:</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="descripcion" placeholder="Descripción de la categoria">
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                      <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarCategoria()">GUARDAR</button>
                      <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarCategoria()">ACTUALIZAR</button>
                  </div>
              </div>
          </div>
          
      </div>
  <!--- FIN MODAL PEDIDO --->

  <!--- MODAL PROVEEDOR --->
  <div v-if="showModalPro">
        
    <div class="modal">
        <div class="modal-overlay"></div>
            <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarProveedor():actualizarProveedor()">
                <div class="modal-header bg-primary text-white">
                    <h4>{{tituloModal}}</h4>
                    <button type="button" class="close" @click="cerrarModalPro()">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Empresa: *</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="empresa" placeholder="Nombre de la empresa">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">RUC: *</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="ruc" placeholder="Número de RUC">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Dirección:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="direccion" placeholder="Dirección">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Correo:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="correo" placeholder="Correo electrónico">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Teléfono:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="telefono" placeholder="Número de teléfono">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Celular:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="celular" placeholder="Número de celular">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Contacto:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="contacto" placeholder="Nombre de la persona de contacto">
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="cerrarModalPro()">Cerrar</button>
                    <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarProveedor()">GUARDAR</button>
                    <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarProveedor()">ACTUALIZAR</button>
                </div>
            </div>
        </div>
        
    </div>
<!--- FIN MODAL PROVEEDOR --->
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Grabando compra, espere...</p>
    </div>
</template>
<script>
    import VueMultiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.css'
    

    export default{
        components:{
            VueMultiselect
        },
      data(){
        return{
          id:'',
          idProveedor:'',
          fechaCompra:'',
          numeroComprob:'',
          arrayProveedor: [],
          proveedSelect:null,
          rucSelect:'',

          productoSelect:[],
          arrayProducto:[],
          arrayAlmacen:[],
          idAlmacen:0,
          arrayUniMedida:[],
          idUnidadMedida:0,
          modelo:null,
          tieneModelo:false,
          serie:null,
          fvencimiento:null,
          conmodelo:false,
          conserie:false,
          confechaven:false,
          
          idEmpresa:'',
          placeholderSelectPro:'Buscar proveedor',

          showModal: false,
          tituloModal: '',
          errorAddListpro:0,
          arrayMostMsjAdd:[],
          tipoAccion: 0,
          txtBuscar:'',
          errorSaveUpdate:[],

          arrayTipoComp:[],
          idTipoComprob:0,

          arrayProductoAdd:[],
          inputCantidad:'',
          inputPrecio:'',
          sumatotal:'',

          showModalPro: false,
          empresa:'',
          ruc:'',
          direccion:'',
          correo:'',
          telefono:'',
          celular:'',
          contacto:'',

          proveedores: [],
          errorProveedor:0,
          arrayMostMsj:[],
          
          loading:false,
        }
      },
      computed: {
        isOnFirstPage() {
        return this.currentPage === 1;
        },
        isOnLastPage() {
        return this.currentPage === this.totalPages;
        },
        sumaTotal(){
          return this.arrayProductoAdd.reduce((subtotal,item) => subtotal + item.subtotal,0)
        }
      },
      methods:{
        formattedTotal(amount) {
            return new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            }).format(amount);
        },
        nameWithLang ({ empresa}) {
            return `${empresa}`
        },
        nameWithLangPro ({ nombre, marca }) {
            return `${nombre} - ${marca}`
        },
        onProductoChange(producto) {
            this.tieneModelo = producto ? producto.tieneModelo : false;
        },
        buscarProveedor(txtBuscar){
            let me = this
            this.$axios.get(`apinventario/proveedores/?search=${txtBuscar}&idEmpresa=${me.idEmpresa}`)
            .then(function(response){
                me.arrayProveedor = response.data.results
            })
        },
        buscarProducto(txtBuscar){
          let me = this
          if(txtBuscar != ''){
            this.$axios.get(`apinventario/productos/?search=${txtBuscar}&idEmpresa=${me.idEmpresa}`)
            .then(function(response){
                const filterProd =  response.data.results.filter(element => element.activo == 1)
                me.arrayProducto = filterProd
            })
          }else{me.arrayProducto = []}
        },
        listarAlmacen(){
            let me = this
              this.$axios.get(`apiempresa/almacen/?idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.arrayAlmacen = response.data
              })
          },
        listarUnidadMedida(){
          let me = this
            this.$axios.get(`apinventario/unidadmedidall/`)
            .then(function(response){
              const arrayfilter = response.data.filter(element => element.activo == 1)
              me.arrayUniMedida = arrayfilter
            })          
        },
        validarAddLisPro(){
          this.errorAddListpro = 0
          this.arrayMostMsjAdd = []
          if(!this.idUnidadMedida) this.arrayMostMsjAdd.push("Seleccione Unidad de Medida")
          if(!this.inputPrecio) this.arrayMostMsjAdd.push("Ingrese precio de compra")
          if(!this.inputCantidad) this.arrayMostMsjAdd.push("Ingrese una cantidad")
          if(this.confechaven && !this.fvencimiento) this.arrayMostMsjAdd.push("Ingrese la fecha de vencimiento del producto")
          if(this.conserie && !this.serie) this.arrayMostMsjAdd.push("Ingrese la serie del producto")
          if(this.conmodelo && !this.modelo) this.arrayMostMsjAdd.push("Ingrese el modelo del producto")
          if(this.productoSelect==null || this.productoSelect == '') this.arrayMostMsjAdd.push("Ingrese un producto")
          const existeProduc = this.arrayProductoAdd.find((element) => element.idpro === this.productoSelect.id)//validar duplicado de producto al array
          if(existeProduc){this.$toastr.error('Producto duplicado!')}
          if(this.arrayMostMsjAdd.length) this.errorAddListpro = 1
          return this.errorAddListpro
        },
        addListProd(){
          //validamos
          if(this.validarAddLisPro()){
              this.arrayMostMsjAdd.forEach(element => {
                this.$toastr.error(element,'Atencion!')
              });
              return
          }
          var subtotal = this.inputCantidad * this.inputPrecio
          this.arrayProductoAdd.push({
            idpro: this.productoSelect.id,
            producto: this.productoSelect.nombre,
            marca:this.productoSelect.marca,
            idUnidadMedida: this.idUnidadMedida.id,
            unidadMedida:this.idUnidadMedida.nombre,
            cantidad: this.inputCantidad,
            modelo:this.modelo,
            serie:this.serie,
            fvencimiento:this.fvencimiento,
            precio: this.inputPrecio,
            subtotal: subtotal,
            
          })
          subtotal = 0
          this.productoSelect = ''
          this.inputCantidad = ''
          this.inputPrecio = ''
          this.idUnidadMedida=0
          this.modelo=''
          this.serie=''
          this.fvencimiento=null
        },
        recalcularItem(index){
          const item = this.arrayProductoAdd[index]
          item.subtotal = item.precio * item.cantidad
        },         
        eliminarItem(index){
          this.arrayProductoAdd.splice(index,1)
        },
     
        validadGrabar(){
          this.errorGrabar = 0
          this.arrayMostMsjGra = []
          if(!this.arrayProductoAdd.length) this.arrayMostMsjGra.push("Agregue un producto a la lista")
          if(!this.fechaCompra) this.arrayMostMsjGra.push("Ingrese una fecha de compra")
          if(!this.idAlmacen) this.arrayMostMsjGra.push("Seleccione el almacen")
          if(!this.numeroComprob) this.arrayMostMsjGra.push("Ingrese un número de comprobante")
          if(!this.idTipoComprob) this.arrayMostMsjGra.push("Seleccione un tipo de comprobante")
          if(this.proveedSelect==null) this.arrayMostMsjGra.push("Ingrese un Proveedor")
          //validar cantidad y costo de la tabla arrayProducAdd
          this.arrayProductoAdd.forEach(element => {
            if(element.subtotal <= 0 || isNaN(element.subtotal)){
              this.arrayMostMsjGra.push("Revisar la tabla de productos, cantidad y precio deben ser números positivos")
              return
            }
          })

          if(this.arrayMostMsjGra.length) this.errorGrabar = 1
          return this.errorGrabar
        },
        grabarCompra(){
          if(this.validadGrabar()){
            this.arrayMostMsjGra.forEach(element => {
              this.$toastr.error(element,'Atencion!')
            });
            return
          }
          let me = this
          this.$swal.fire({
          title: 'Registrar nueva compra?',
          text: "El STOCK de los productos se actualizaran",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Registrar!'
        }).then((result) => {
            me.loading=true
          if (result.isConfirmed) {
            let detalleArray = this.arrayProductoAdd.map((detalle)=>{
            return {
              idProducto: detalle.idpro,
              modelo:detalle.modelo ? detalle.modelo.toUpperCase().trim() : null,
              serie:detalle.serie ? detalle.serie.toUpperCase().trim() : null,
              fechaVencimiento:detalle.fvencimiento,
              cantidad: detalle.cantidad,
              precioUnitario: detalle.precio,
              idUnidadMedida: detalle.idUnidadMedida,
              subtotal: detalle.subtotal,
            }
            })
            this.$axios.post(`apinventario/compras/`, { //URL GRABAR COMPRA
                fecha: me.fechaCompra,
                numeroComprob: (me.numeroComprob.toUpperCase()).trim(),
                compraTotal: me.sumatotal,
                idProveedor: me.proveedSelect.id,
                idTipoComprob: me.idTipoComprob,
                idEmpresa:me.idEmpresa,
                idAlmacen:me.idAlmacen,
                detalles: detalleArray,
            }).
            then((response)=>{
              console.log(response.data)
              me.$router.push('/compras/')
              me.$toastr.success('Nueva compra agregado', 'Registrado')
              me.$socket.send(JSON.stringify({
                'message':'nueva compra'
              }))
            }).
            catch((error)=>{
              console.error(error)
              me.$toastr.error('Hubo un error al registrar compra', 'Error');
            })
            .finally(()=>{
                me.loading = false  // ⬅ ocultar spinner siempre
            })
          }else{
            me.loading=false
          }
        })

        },
        abrirModal(action, data=[]){
          switch(action){
            case "registrar":{
                this.showModal = true
                this.tituloModal = "Nueva categoria"
                this.tipoAccion = 1
                break
            }
            case "actualizar":{
                this.showModal = true
                this.tituloModal = "Editar categoria"
                this.id = data['id']
                this.nombre = data['nombre']
                this.descripcion = data['descripcion']
                this.tipoAccion = 2
                break
            }
          }                
        },
        cerrarModal(){
            this.showModal = false;
            this.id = ''
            this.nombre = ''
            this.descripcion = ''
        },
        abrirModalPro(action, data=[]){
          switch(action){
              case "registrar":{
                  this.showModalPro = true
                  this.tituloModal = "Nuevo proveedor"
                  this.tipoAccion = 1
                  break
              }
              case "actualizar":{
                  this.showModalPro = true
                  this.tituloModal = "Editar proveedor"
                  this.id = data['id']
                  this.empresa = data['empresa']
                  this.ruc = data['ruc']
                  this.direccion = data['direccion']
                  this.correo = data['correo']
                  this.telefono = data['telefono']
                  this.celular = data['celular']
                  this.contacto = data['contacto']
                  this.tipoAccion = 2
                  break
              }
          }                
        },
        cerrarModalPro(){
            this.showModalPro = false;
            this.id = ''
            this.empresa = ''
            this.ruc = ''
            this.direccion = ''
            this.correo = ''
            this.telefono = ''
            this.celular = ''
            this.contacto = ''
        },       
        validarProveedor(){
          this.errorProveedor = 0
          this.arrayMostMsj = []
          if(!this.empresa.trim()) this.arrayMostMsj.push("Ingrese el nombre de la Empresa")
          if(!this.ruc.trim()) this.arrayMostMsj.push("Ingrese el RUC de la Empresa")
          if(this.arrayMostMsj.length) this.errorProveedor = 1
          return this.errorProveedor
        },
        registrarProveedor(){
          if(this.validarProveedor()){
              this.arrayMostMsj.forEach(element => {
                  this.$toastr.error(element,'Atencion!')
              });
              return
          }
          let me = this
          this.$axios.post(`apinventario/proveedores/`, {
              empresa: (me.empresa.toUpperCase()).trim(),
              ruc: me.ruc.trim(),
              direccion: me.direccion.trim(),
              correo: me.correo.trim(),
              telefono: me.telefono.trim(),
              celular: me.celular.trim(),
              contacto: me.contacto.trim(),
              idEmpresa:me.idEmpresa,
          })
          .then(function (response) {
              me.cerrarModalPro()
              console.log(response)
              me.$toastr.success('Nuevo proveedor registrado', 'Registrado');
          })
        },
        fechaFormateada(fecha) {
            if(fecha){
                const partes = fecha.split('-');
                return `${partes[2]}/${partes[1]}/${partes[0]}`;
            }else{
                return ''
            }
        },
      },
          
      watch: {
         
      },
      mounted(){
        this.idEmpresa = localStorage.getItem('idEmpresa')
        let me = this
        this.$axios.get(`apiempresa/tipocomprobante/`)
        .then(function(response){
          if(response.data.length){
              me.arrayTipoComp = response.data.slice(0,2)
          }
        })
        this.listarAlmacen()
        this.listarUnidadMedida()
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>